import { IconBrain, IconEye, IconMessageCircle, IconSettings, IconZoomCode } from '@tabler/icons-react';

import type { MobileBottomNavItem } from '@/components/ui/MobileBottomNav';
import { ROUTES } from '@/configs/routes';
import type { DocumentSectionSlug } from '@/entities/OrganizationSection';

import { TabKey } from './types';

export type DocumentTabKey = TabKey.documentPreview | TabKey.aiSummary | TabKey.analyze | TabKey.properties;

export const MOBILE_TABS: MobileBottomNavItem[] = [
  { key: TabKey.documentPreview, label: 'Документ', icon: <IconEye size={20} /> },
  { key: TabKey.analyze, label: 'Анализ', icon: <IconZoomCode size={20} /> },
  { key: TabKey.aiSummary, label: 'Саммари', icon: <IconBrain size={20} /> },
  { key: TabKey.properties, label: 'Свойства', icon: <IconSettings size={20} /> },
  { key: TabKey.chat, label: 'Чат с ИИ', icon: <IconMessageCircle size={20} /> },
];

export const TAB_KEY_TO_DOCUMENT_SECTION: Partial<Record<TabKey, DocumentSectionSlug>> = {
  [TabKey.documentPreview]: 'document-preview',
  [TabKey.aiSummary]: 'ai-summary',
  [TabKey.analyze]: 'analyze',
};

export const DOCUMENT_SECTION_TO_TAB_KEY = {
  'document-preview': TabKey.documentPreview,
  'ai-summary': TabKey.aiSummary,
  analyze: TabKey.analyze,
} as const satisfies Record<DocumentSectionSlug, DocumentTabKey>;

export const getTabRoute = (key: TabKey, organizationId: number, documentId: string) => {
  switch (key) {
    case TabKey.summary:
      return ROUTES.organization.documents.document.summary.create(organizationId.toString(), documentId);
    case TabKey.aiSummary:
      return ROUTES.organization.documents.document.aiSummary.create(organizationId.toString(), documentId);
    case TabKey.analyze:
      return ROUTES.organization.documents.document.analyze.create(organizationId.toString(), documentId);
    case TabKey.properties:
      return ROUTES.organization.documents.document.properties.create(organizationId.toString(), documentId);
    case TabKey.documentPreview:
      return ROUTES.organization.documents.document.documentPreview.create(organizationId.toString(), documentId);
    case TabKey.chat:
      return ROUTES.organization.documents.chat.create(organizationId.toString(), documentId);
  }
};
